import { useState, useEffect } from 'react';
import './CountDownTimer.css';
import playButtonImage from './images/play-button-white.svg';
import pauseButtonImage from './images/pause-button-white.svg';

function CountDownTimer ({ startValue }) {
    const [timeLeftMs, setTimeLeftMs] = useState(startValue * 1000);
    const [intervalId, setIntervalId] = useState(0);
    let lastTickTime = null;

    useEffect( () => () => { console.log("unmount"); clearInterval(intervalId); }, [intervalId] );

    function formatTimeField(time) {
        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time % 60);

        return minutes.toString().padStart(2, "0") + ":" + seconds.toString().padStart(2, "0");
    }

    function tick() {
        let currentTime = Date.now();
        let diff = currentTime - lastTickTime;
        lastTickTime = currentTime;
        setTimeLeftMs(prevState => prevState - diff);
    }

    function startTimer() {
        lastTickTime = Date.now();
        const newIntervalId = setInterval(() => tick(), 200);
        setIntervalId(newIntervalId);
    }

    function pauseTimer() {
        clearInterval(intervalId);
        setIntervalId(0);
    }

    return (
        <div className="timer-container">
            <div className="timer-screen">
                { (timeLeftMs >= 0) && <span className="digits">{formatTimeField(timeLeftMs / 1000)}</span> }
                { (timeLeftMs < 0) && <span className="digits timeout">00:00</span> }
            </div>
            <div className="controls">
                <span className="control-element controls-play" onClick={startTimer}>
                    <img alt='play button' src={`${playButtonImage}`}></img>
                </span>
                <span className="control-element controls-pause" onClick={pauseTimer}>
                    <img alt="pause button" src={`${pauseButtonImage}`} ></img>
                </span>
            </div>
        </div>
    );
}

export default CountDownTimer;